import { render, staticRenderFns } from "./dict_management.vue?vue&type=template&id=5f46c75e&scoped=true"
import script from "./dict_management.vue?vue&type=script&lang=js"
export * from "./dict_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f46c75e",
  null
  
)

export default component.exports